module.exports = __webpack_public_path__ + "media/application/images/testimonials/shopify-app-store-write-a-review-button-da529030e117b064aeb250dc0cb4b909.png";